/* This is a mst-gql generated file, don't modify it manually */
 

import { types } from "mobx-state-tree"
import { MSTGQLRef, QueryBuilder } from "mst-gql"
import { ModelBase } from "./ModelBase"
import { AppointmentLimitReachedModel } from "./AppointmentLimitReachedModel"
import { AppointmentLimitReachedModelSelector } from "./AppointmentLimitReachedModel.base"
import { AppointmentModel } from "./AppointmentModel"
import { AppointmentModelSelector } from "./AppointmentModel.base"
import { AppointmentRequestModel } from "./AppointmentRequestModel"
import { AppointmentRequestModelSelector } from "./AppointmentRequestModel.base"
import { AppointmentUnavailableModel } from "./AppointmentUnavailableModel"
import { AppointmentUnavailableModelSelector } from "./AppointmentUnavailableModel.base"
import { BookDolphinAppointmentResultModelSelector } from "./BookDolphinAppointmentResultModelSelector"
import { BookPmsAppointmentResultModelSelector } from "./BookPmsAppointmentResultModelSelector"
import { DayOfWeekMismatchModel } from "./DayOfWeekMismatchModel"
import { DayOfWeekMismatchModelSelector } from "./DayOfWeekMismatchModel.base"
import { DolphinBookingIntentModel } from "./DolphinBookingIntentModel"
import { DolphinBookingIntentModelSelector } from "./DolphinBookingIntentModel.base"
import { Locale } from "./LocaleEnum"
import { PmsBookingIntentModel } from "./PmsBookingIntentModel"
import { PmsBookingIntentModelSelector } from "./PmsBookingIntentModel.base"
import { ReservationUnavailableModel } from "./ReservationUnavailableModel"
import { ReservationUnavailableModelSelector } from "./ReservationUnavailableModel.base"
import { DolphinPatientInput, PatientInput, PmsPatientInput } from "./RootStore.base"
import { UserInputValidationFailedModel } from "./UserInputValidationFailedModel"
import { UserInputValidationFailedModelSelector } from "./UserInputValidationFailedModel.base"


/**
 * RootMutationTypeBase
 * auto generated base class for the model RootMutationTypeModel.
 */
export const RootMutationTypeModelBase = ModelBase
  .named('RootMutationType')
  .props({
    __typename: types.optional(types.literal("RootMutationType"), "RootMutationType"),
    /** Book an appointment */
    bookAppointment: types.union(types.undefined, types.null, MSTGQLRef(types.late(() => AppointmentModel))),
    /** Book a Dolphin appointment */
    bookDolphinAppointment: types.union(types.undefined, types.null, types.union(types.late(() => UserInputValidationFailedModel), types.late(() => ReservationUnavailableModel), MSTGQLRef(types.late(() => DolphinBookingIntentModel)), types.late(() => AppointmentLimitReachedModel))),
    /** Book a PMS appointment */
    bookPmsAppointment: types.union(types.undefined, types.null, types.union(MSTGQLRef(types.late(() => PmsBookingIntentModel)), types.late(() => UserInputValidationFailedModel), types.late(() => AppointmentUnavailableModel), types.late(() => DayOfWeekMismatchModel), types.late(() => AppointmentLimitReachedModel))),
    /** Create an appointment */
    createAppointment: types.union(types.undefined, types.null, MSTGQLRef(types.late(() => AppointmentModel))),
    /** Request an appointment */
    requestAppointment: types.union(types.undefined, types.null, MSTGQLRef(types.late(() => AppointmentRequestModel))),
    /** Update an appointment */
    updateAppointment: types.union(types.undefined, types.null, MSTGQLRef(types.late(() => AppointmentModel))),
  })
  .views(self => ({
    get store() {
      return self.__getStore()
    }
  }))

export class RootMutationTypeModelSelector extends QueryBuilder {
  bookAppointment(builder, args) { return this.__child(`bookAppointment` + (args ? '(' + ['appointmentId', 'locale', 'locationId', 'partnerId', 'patient', 'providerId', 'referrer', 'source'].map((argName) => ((args)[argName] ? `${argName}: ${JSON.stringify((args)[argName])}` : null)).filter((v) => v != null).join(', ') + ')' : ''), AppointmentModelSelector, builder) }
  bookDolphinAppointment(builder) { return this.__child(`bookDolphinAppointment`, BookDolphinAppointmentResultModelSelector, builder) }
  bookPmsAppointment(builder) { return this.__child(`bookPmsAppointment`, BookPmsAppointmentResultModelSelector, builder) }
  createAppointment(builder, args) { return this.__child(`createAppointment` + (args ? '(' + ['appointmentTypeId', 'end', 'locationId', 'providerId', 'start'].map((argName) => ((args)[argName] ? `${argName}: ${JSON.stringify((args)[argName])}` : null)).filter((v) => v != null).join(', ') + ')' : ''), AppointmentModelSelector, builder) }
  requestAppointment(builder, args) { return this.__child(`requestAppointment` + (args ? '(' + ['isEmergency', 'locale', 'locationId', 'partnerId', 'patient', 'providerId', 'referrer', 'source', 'yapiRequest'].map((argName) => ((args)[argName] ? `${argName}: ${JSON.stringify((args)[argName])}` : null)).filter((v) => v != null).join(', ') + ')' : ''), AppointmentRequestModelSelector, builder) }
  updateAppointment(builder, args) { return this.__child(`updateAppointment` + (args ? '(' + ['appointmentTypeId', 'end', 'id', 'locationId', 'providerId', 'start'].map((argName) => ((args)[argName] ? `${argName}: ${JSON.stringify((args)[argName])}` : null)).filter((v) => v != null).join(', ') + ')' : ''), AppointmentModelSelector, builder) }
}
export function selectFromRootMutationType() {
  return new RootMutationTypeModelSelector()
}

export const rootMutationTypeModelPrimitives = selectFromRootMutationType()
